import StatsBar from './StatsBar';

export default StatsBar;
